<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row v-if="dataList.length > 0">
          <b-col
            v-for="item in dataList"
            :key="item.id"
            class="mb-3"
            cols="6"
            md="4"
            lg="3"
          >
            <media-item
              :data-item="item"
              :get-data-list="getDataList"
              :is-view="isView"
            />
          </b-col>
        </b-row>
        <div
          v-else
          class="alert-body text-center py-3 bordered border rounded"
        >
          <div>
            <FeatherIcon
              icon="CameraIcon"
              size="36"
            />
          </div>
          <div class="mt-1">
            Henüz yüklenmiş medya dosyası bulunamadı.
          </div>
        </div>
      </b-card-body>
      <b-card-footer v-if="dataList.length > 0">
        <b-pagination
          v-if="dataCounts > perPage"
          v-model="currentPage"
          :total-rows="dataCounts"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon
              icon="ChevronLeftIcon"
              size="18"
            />
          </template>
          <template #next-text>
            <feather-icon
              icon="ChevronRightIcon"
              size="18"
            />
          </template>
        </b-pagination>
      </b-card-footer>
    </b-card>
    <upload-card
      v-if="!isView"
      :get-data-list="getDataList"
    />
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BCardFooter, BPagination, BCardBody,
} from 'bootstrap-vue'
import MediaItem from '@/views/Projects/elements/MediaCard/MediaItem.vue'
import UploadCard from '@/views/Projects/elements/MediaCard/UploadCard.vue'

export default {
  name: 'MediaCard',
  components: {
    BPagination,
    BCardFooter,
    BCard,
    BRow,
    BCol,
    BCardBody,
    MediaItem,
    UploadCard,
  },
  props: {
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      dataQuery: {
        where: {
          'media_gallery.item_id': this.$route.params.id,
        },
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['projectMediaGallery/dataList']
    },
    dataCounts() {
      return this.$store.getters['projectMediaGallery/dataCounts']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('projectMediaGallery/getDataList', this.dataQuery)
    },
  },
}
</script>
